import React, { useEffect, useState } from "react";
import Pagination from "../components/Pagination";
import { Button, DropdownButton, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { voucher } from "../constant/imagepath";
import DatePicker from "react-date-picker";
import { URL } from "../Config/apiUrl";
import { Post, Patch } from "../Axios/AxiosFunctions";
import { useHistory } from "react-router-dom";
// import { SpinnerRoundOutlined } from "spinners-react";

function AddNewAdmin(props) {
  const accessToken = useSelector((state) => state.globalReducer.accessToken);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [limit, setLimit] = useState(10);
  const [addVoucher, setAddVoucher] = useState("Voucher 1");
  const [pageNumber, setPageNumber] = useState(1);
  const [maxLength, setMaxLength] = useState(0);
  // const { setChoice } = props;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  let history = useHistory();

  const [loading, setLoading] = useState(false);

  //   useEffect(() => {
  //     // dispatch(getNewMentors());
  //     var config = {
  //       method: "get",
  //       url: NODE_URL(
  //         `transaction/pending-withdraws?limit=${limit}&page=${pageNumber}&addVoucher=${addVoucher}`
  //       ),
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     };
  //     axios(config)
  //       .then(function (response) {
  //         let maxLastLength =
  //           pageNumber === 1 ? pageNumber * limit : (pageNumber - 1) * limit;
  //         setMaxLength(maxLastLength);
  //         setPaymentRequests(response.data.data);
  //         console.log(response.data.data, "=================================");
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   }, [pageNumber, addVoucher]);

  //   const approve = (id) => {
  //     console.log(id);
  //     var config = {
  //       method: "get",
  //       url: NODE_URL(
  //         `transaction/clear-pending-list?addVoucher=${AddVoucher}`
  //       ),
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //       },
  //     };
  //     axios(config)
  //       .then(function (response) {
  //         console.log(response);
  //       })
  //       .catch(function (error) {
  //         console.log(error);
  //       });
  //   };

  const PaymentRequestData = [
    {
      id: 1,
      name: "Daniyal",
      m_id: "00126u7565876",
      balance: "$1000",
      noOfSessios: 5,
      noOfMentees: 11,
      country: "Germany",
      data: "Edinburgh",
    },
    {
      id: 2,
      name: "Ahsan",
      m_id: "00189u7371160",
      balance: "$16000",
      noOfSessios: 7,
      noOfMentees: 10,
      country: "Germany",
      data: "Edinburgh",
    },
    {
      id: 3,
      name: "Qasim",
      m_id: "0033124u73788g8",
      balance: "$1300",
      noOfSessios: 4,
      noOfMentees: 13,
      country: "Germany",
      data: "Edinburgh",
    },
    {
      id: 4,
      name: "Ehtisham",
      m_id: "00173124u73786",
      balance: "$1800",
      noOfSessios: 8,
      noOfMentees: 10,
      country: "Germany",
      data: "Edinburgh",
    },
    {
      id: 5,
      name: "Basit",
      m_id: "001ff3124u73800",
      balance: "$2200",
      noOfSessios: 10,
      noOfMentees: 7,
      country: "Germany",
      data: "Edinburgh",
    },
  ];

  const authHeader = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  };

  console.log("access token", accessToken);

  const AddNewVoucherHandler = async () => {
    console.log("add functio run");
    // setAddServiceTypesModal(false);
    const addServiceType = URL(`create-admins`);
    setLoading(true);
    let obj = {
      email: email,
      password: password,
      passwordConfirm: confirmPassword,
      role: "admin",
    };
    const responseData = await Post(addServiceType, obj, authHeader);
    if (responseData !== undefined) {
      // console.log({addServicesTypes})
      console.log("add new admin test", responseData);
      alert(responseData.data.status);
      history.push("/AdminList");
      //   let oldData = addServicesTypes.slice();
      //   oldData.push(responseData?.data?.data)
      //   console.log({oldData})
      //   setAddServicesTypes(oldData)
      // setAddServiceTypesModal(false);
      //   console.log("qasim api add service", responseData?.data);
    }
    setLoading(false);
  };

  return (
    <>
      {/* <!-- Begin Page Content --> */}
      <div className="container-fluid newMentorRequests">
        {/* <!-- Page Heading --> */}
        <h1 className="h3 mb-2 text-gray-800">Add New Admin</h1>
        {/* <p className="mb-4">Add Voucher List</p> */}

        {/* <!-- DataTales Example --> */}
        <div className="card shadow mb-4">
          <div className="card-header py-3 d-flex">
            <h6 className="m-0 font-weight-bold text-primary"></h6>
          </div>
          <div className="card-body">
            <div className="table-responsive" style={{ overflowX: "hidden" }}>
              <div className="row">
                <div className="col-md-9">
                  <div className="inputFields-container">
                    <p className="fieldText">Email :</p>
                    <input
                      className="inputBoxAdmin"
                      type="text"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="inputFields-container">
                    <p className="fieldText">Password :</p>
                    <input
                      className="inputBoxAdmin"
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <div className="inputFields-container">
                    <p className="fieldText">Confirm Password :</p>
                    <input
                      className="inputBoxAdmin"
                      type="password"
                      placeholder="Confirm Password"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>
                  {/* <div className="inputFields-container">
                          <p>Confirm Password :</p>
                            <input 
                                // className="inputBox"
                                type="checkbox"
                                value={role}
                                onChange={(e)=>setConfirmPassword(e.target.value)}
                            />
                        </div> */}
                  {/* <input type="checkbox" id="vehicle1" name="vehicle1" value="Bike">
                            <label for="vehicle1"> I have a bike</label> */}
                </div>
              </div>

              <div style={{ width: "100px", marginTop: "38px" }}>
                <Button
                  className={`btn btn-user btn-block btn-approved`}
                  onClick={() => AddNewVoucherHandler()}
                  disabled={loading}
                >
                  {loading ? "loading" : " Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /.container-fluid --> */}
    </>
  );
}

export default AddNewAdmin;
